import { handleActions } from 'redux-actions';
import { reject } from 'lodash';

import { CancerQuote } from '@models/CancerQuote';

import {
  compareAdd,
  CompareAddPayload,
  compareRemove,
  CompareRemovePayload,
  compareRemoveAll,
  stateUpdate,
  State,
} from './action';

const initialState: State = {
  comparableCancerQuotes: [],
};

const reducer = handleActions(
  {
    [String(compareAdd)]: (state, { payload }) => {
      const { cancerQuote } = payload as unknown as CompareAddPayload;

      return {
        ...state,
        comparableCancerQuotes: [...state.comparableCancerQuotes, cancerQuote] as CancerQuote[],
      };
    },

    [String(compareRemove)]: (state, { payload }) => {
      const { cancerQuote } = payload as unknown as CompareRemovePayload;

      return {
        ...state,
        comparableCancerQuotes: reject(state.comparableCancerQuotes, {
          cancerPlanId: cancerQuote.cancerPlanId,
        }),
      };
    },

    [String(compareRemoveAll)]: (state) => {
      return {
        ...state,
        comparableCancerQuotes: [],
      };
    },

    [String(stateUpdate)]: (state, { payload }) => {
      return {
        ...state,
        ...payload,
      };
    },
  },

  initialState,
);

export default reducer;
